<template>
  <div class="trial-bar-container" v-if="serviceInfo.plan && serviceInfo.plan.trial">
    <div class="side-bar">
      <div>
        무료체험 <span class="primary">D-{{ serviceInfo.plan.d_day }}</span>
      </div>
      <button class="button is-primary" @click="clickPlan">{{ accountName }}</button>
    </div>
    <div class="trial-notice">
      <sweet-modal ref="modal" overlay-theme="light" width="1000px" @close="onClose">
        <div class="trial-notice-content">
          <img :src="imgSrc('img_trial_trash')" alt="무료체험 삭제 경고">
          <div class="size-24 weight-700" style="margin-bottom:8px">무료체험이 <span class="primary">{{ serviceInfo.plan.d_day }}</span>일 남았습니다.</div>
          <div class="size-18 weight-500">무료체험기간에 {{ accountName }}를 하지 않으시면, 서비스는 삭제됩니다.</div>
          <button v-if="!hasOrder" class="button is-dark button-dark-large" @click="clickPlan">👏 첫 구매 최대 44% 추가 할인받고 결제하기</button>
          <button v-else class="button is-primary button-primary-large" @click="clickPlan">{{ accountName }}</button>

          <div style="margin-top:20px">
            <lp-check-bool :checked-val.sync="checked"
                           label="오늘 하루 보지 않기"></lp-check-bool>
          </div>
        </div>
      </sweet-modal>
    </div>
  </div>
</template>

<script>
  import { SweetModal } from "sweet-modal-vue";
  import LpCheckBool from "./LpCheckBool";
  export default {
    name: "TrialBar",
    components: {
      LpCheckBool,
      SweetModal
    },
    created() {
      this.today = this.moment().format('YYYY-MM-DD');
      this.getHasOrder();
    },
    computed: {
      accountName() {
        return `${this.serviceInfo.service_type === 4 ? '플랜' : '스킨'} 결제`
      }
    },
    data() {
      return {
        hasOrder: true,
        service: undefined,
        today: '',
        checked: false
      }
    },
    methods: {
      onClose() {
        if(this.checked) {
          this.$store.commit('setTrialPopUpDate', this.today);
        }
      },
      clickPlan() {
        this.$refs.modal.close();
        this.$root.$emit('planChangeModal');
      },
      getHasOrder() {
        this.$axios.get(`${this.masterBackendUrl}serviceadmin/${this.$store.getters.admin.id}/launchpack/service/${this.$store.getters.masterService.service_id}/has_order`).then(res => {
          this.hasOrder = res.data.result;
          this.getData();
        });
      },
      getData() {
        if(this.serviceInfo.plan && this.serviceInfo.plan.trial && this.$route.path === '/office/admin/dashboard') {
          if(this.$store.getters.trialPopUpDate === '') {
            this.$store.commit('setTrialPopUpDate', 'none');
          } else if(this.$store.getters.trialPopUpDate !== this.today) {
            this.$nextTick(()=>{
              this.$refs.modal.open();
            });
          }
        }
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .trial-bar-container
    position fixed
    z-index 1024
    bottom 0
    left 0
    width 100%

  .side-bar
    border-top 1px solid #787878
    width 230px
    padding 12px 20px
    display flex
    align-items center
    color white
    background-color #32373F
    justify-content space-between

  .light-blue
    color #7efff7
  .is-lightblue
    border 0
    color #7B61FF
    font-weight 700

  .trial-notice-content
    text-align center
    img
      margin-bottom 40px
    .button-primary-large
      margin-top 20px
      width 130px
      height 48px !important
      font-size 16px !important
      font-weight 700

  .button-dark-large
    margin-top 20px
    width unset
    height 56px !important
    padding 16px 24px
    color white
    font-size 16px !important

</style>
<style lang="stylus">
  .trial-notice
    .sweet-modal.is-alert .sweet-content
      padding-bottom 32px
</style>
